import tabs from '@/components/generics/tabs/tabs.vue';

const SCROLL_BUTTON_UPDATE_DELAY = 250;
const SCROLL_EDGE_TOLERANCE = 25;
const TAB_BOUNDARY_TOLERANCE = 2;

export default {
  components: {
    tabs,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    theme: {
      type: String,
      default: 'wallet',
    },
    activeTab: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showNavigationArrows: false,
      canScrollLeft: false,
      canScrollRight: false,
    };
  },
  watch: {
    items() {
      this.$nextTick(() => this.checkOverflow());
    },
  },
  methods: {
    onTabChange(name) {
      this.$emit('tabChange', name);
    },
    checkScrollButtons() {
      const tabsList = this.$refs.tabsList;
      if (tabsList) {
        this.canScrollLeft = tabsList.scrollLeft > SCROLL_EDGE_TOLERANCE;
        this.canScrollRight =
          tabsList.scrollLeft < tabsList.scrollWidth - tabsList.clientWidth - SCROLL_EDGE_TOLERANCE;
      }
    },
    checkOverflow() {
      const tabsList = this.$refs.tabsList;
      if (tabsList) {
        this.showNavigationArrows = tabsList.scrollWidth > tabsList.clientWidth;
        setTimeout(() => {
          this.checkScrollButtons();
        }, SCROLL_BUTTON_UPDATE_DELAY);
      }
    },
    scrollToNextTabBoundary(direction) {
      const tabsList = this.$refs.tabsList;
      if (!tabsList) return;
      const items = Array.from(tabsList.querySelectorAll('.tabs__item'));
      const current = tabsList.scrollLeft;
      let target = current;
      if (items.length > 0) {
        if (direction > 0) {
          const next = items.find((item) => item.offsetLeft > current + TAB_BOUNDARY_TOLERANCE);
          target = next ? next.offsetLeft : tabsList.scrollWidth;
        } else {
          const previous = items
            .filter((item) => item.offsetLeft < current - TAB_BOUNDARY_TOLERANCE)
            .pop();
          target = previous ? previous.offsetLeft : 0;
        }
      }
      tabsList.scrollTo({ left: target, behavior: 'smooth' });
      setTimeout(() => {
        this.checkScrollButtons();
      }, SCROLL_BUTTON_UPDATE_DELAY);
    },
    scrollLeft() {
      this.scrollToNextTabBoundary(-1);
    },
    scrollRight() {
      this.scrollToNextTabBoundary(1);
    },
    handleWindowResize() {
      this.checkOverflow();
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleWindowResize);
    this.$nextTick(() => {
      this.checkOverflow();
      const tabsList = this.$refs.tabsList;
      if (tabsList) {
        tabsList.addEventListener('scroll', this.checkScrollButtons);
      }
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
    const tabsList = this.$refs.tabsList;
    if (tabsList) {
      tabsList.removeEventListener('scroll', this.checkScrollButtons);
    }
  },
};
